/**
 * 获取登录后存放的全局token
 * @param state
 */
 export default {

}
